'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _graphql = require('graphql');

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _Paper = require('material-ui/Paper');

var _Paper2 = _interopRequireDefault(_Paper);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _ResultViewer2 = require('graphiql/dist/components/ResultViewer');

var _ResultView = require('./ResultView');

var _ResultView2 = _interopRequireDefault(_ResultView);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Иерархия:
 * 
 * Document: {Definition}
 *  kind
 *  definitions: {Definition}
 *    kind: OperationDefinition
 *    name: {}
 *    operation: query | mutation | subscription
 *    alias {}
 *    arguments: [{}]
 *    directives: [{}]
 *    variableDefinitions: [{}]: 
 *      kind
 *      defaultValue: {}
 *        fields: [{}]:
 *          kind
 *          name: {}
 *          value: {}
 *      type: {}
 *      variable: {}
 *        kind: 
 *        name: {}
 *    selectionSet:
 *      kind
 *      selections: [{Definition}]
 */
// import {
//   parse,
// } from "graphql-js/dist/language";


var styles = function styles(theme) {
  return {
    root: {
      height: "100%",
      overflow: "auto",
      // margin: "10px 0",
      // padding: "20px 0",
      // borderTop: "1px solid #ddd",
      // borderBottom: "1px solid #ddd",
      "& button span": {
        textTransform: "none"
      }
    },
    node: {
      margin: "10px 0 10px 20px"
    },
    block: {
      margin: "10px 0 10px 20px"
    },
    paper: {
      margin: "10px 0",
      padding: 10
    },
    definition: {
      "& .OperationDefinition": {
        margin: "10px 0",
        padding: 10
      },
      "& .Field": {
        margin: "10px"
      }
    }
  };
};

var QueryBuilderUI = function (_Component) {
  _inherits(QueryBuilderUI, _Component);

  function QueryBuilderUI(props) {
    _classCallCheck(this, QueryBuilderUI);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = _extends({}, _Component.prototype.state, {
      point: 0
    });
    var query = props.query;

    if (_this.isValidQuery(query)) {
      Object.assign(_this.state, {
        query: query
      });
    }

    return _this;
  }

  QueryBuilderUI.prototype.isValidQuery = function isValidQuery(query) {
    var parseError = void 0;

    try {
      query && (0, _graphql.parse)(query);
    } catch (error) {
      console.error("isValidQuery", error);
      parseError = error;
    }

    Object.assign(this.state, {
      parseError: parseError
    });
    return !parseError;
  };

  QueryBuilderUI.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextState) {
    var nextQuery = nextProps.query;
    var query = this.props.query;

    if ((nextQuery || query) && nextQuery !== query && this.isValidQuery(nextQuery)) {
      this.setState({
        query: nextQuery
      });
    }

    _Component.prototype.componentWillReceiveProps && _Component.prototype.componentWillReceiveProps.call(this, nextProps, nextState);
  }; // componentDidUpdate(prevProps, prevState) {
  //   const {
  //     query: prevQuery,
  //   } = prevProps;
  //   const {
  //     query,
  //   } = this.props;
  //   if ((prevQuery || query) && prevQuery !== query) {
  //     this.assignQuery();
  //   }
  // }


  QueryBuilderUI.prototype.renderDocumentFromSchema = function renderDocumentFromSchema() {
    var elements = [];
    var schema = this.props.schema;
    var query = this.state.query;
    var AST = void 0;
    AST = query && (0, _graphql.parse)(query);

    if (!AST) {
      return null;
    }

    var errors = void 0;
    var outputResults = void 0;

    if (schema && AST) {
      errors = (0, _graphql.validate)(schema, AST);

      if (!errors.length) {
        outputResults = _react2.default.createElement(_ResultView2.default, {
          query: query,
          schema: schema,
          AST: AST
        });
      }
    }

    return _react2.default.createElement('div', null, errors && errors.length ? _react2.default.createElement('div', null, errors.map(function (error, index) {
      return _react2.default.createElement(_Typography2.default, {
        key: index,
        color: 'error'
      }, error.toString());
    })) : null, _react2.default.createElement('div', null, this.renderDefinition(AST)));
  };

  QueryBuilderUI.prototype.addVariable = function addVariable(currentState, variablesState) {
    var string = currentState.token.string;
    var isStart = string === "$";
    var variableArray = void 0;
    var variables = variablesState.variables,
        args = variablesState.args;

    if (isStart) {
      variableArray = [];
      variables.push(variableArray);
    } else {
      variableArray = variables[variables.length - 1];
    }

    variableArray.push(currentState);
  };

  QueryBuilderUI.prototype.injectQuery = function injectQuery(subQuery, line, col) {
    var query = this.props.query;
    var lines = query.split('\n');
    var editLine = lines[line];

    if (editLine !== undefined) {
      editLine = this.replaceRange(editLine, col, col, subQuery);
      lines[line] = editLine;
      query = lines.join('\n');
    }

    return this.setQuery(query);
  };

  QueryBuilderUI.prototype.replaceRange = function replaceRange(string, start, end, substitute) {
    return string.substring(0, start) + substitute + string.substring(end);
  };

  QueryBuilderUI.prototype.updateNode = function updateNode(node, value) {
    var _node$loc = node.loc,
        start = _node$loc.start,
        end = _node$loc.end,
        query = _node$loc.source.body,
        kind = node.kind;

    switch (kind) {
      case "StringValue":
        value = '"' + value.replace(/\\/g, '\\\\').replace(/\"/g, '\\"') + '"';
        break;
    }

    var newQuery = this.replaceRange(query, start, end, value);
    this.setQuery(newQuery);
  };

  QueryBuilderUI.prototype.setQuery = function setQuery(query) {
    var setQuery = this.props.setQuery;
    return setQuery(query);
  };

  QueryBuilderUI.prototype.renderDefinition = function renderDefinition(node) {
    var output = [];
    var kind = node.kind;

    switch (kind) {
      case "Document":
        output.push(this.renderDocument(node));
        break;

      case "OperationDefinition":
      case "Field":
        output.push(this.renderOperationDefinition(node));
        break;
    }

    return output;
  };

  QueryBuilderUI.prototype.renderDocument = function renderDocument(node) {
    var output = void 0;
    var kind = node.kind,
        definitions = node.definitions;
    var classes = this.props.classes;
    return _react2.default.createElement(_Paper2.default, {
      key: kind,
      className: classes.paper
    }, 'Document', _react2.default.createElement('div', null, this.renderDefinitions(definitions)));
  };

  QueryBuilderUI.prototype.renderOperationDefinition = function renderOperationDefinition(node) {
    var _this2 = this;

    var output = void 0;
    var kind = node.kind,
        name = node.name,
        alias = node.alias,
        selectionSet = node.selectionSet,
        directives = node.directives;
    var classes = this.props.classes;

    var _ref = selectionSet || {},
        selections = _ref.selections;

    var nameValue = name && name.value || "";
    var aliasValue = alias && alias.value || "";
    var directivesList = [];
    directives && directives.map(function (n) {
      var args = n.arguments,
          directiveName = n.name;
      var directiveNameValue = directiveName && directiveName.value || "";
      directivesList.push(_react2.default.createElement('div', {
        key: directiveNameValue,
        className: classes.block
      }, 'DirectiveName: ', directiveNameValue, args && args.map(function (arg) {
        var name = arg.name;
        return _react2.default.createElement('div', {
          key: name.value
        }, _this2.renderArgument(arg));
      }) || null));
    });
    return _react2.default.createElement('div', {
      key: kind + '_' + nameValue + '_' + aliasValue,
      className: [classes.definition, kind].join(" ")
    }, _react2.default.createElement(_Typography2.default, {
      variant: 'title'
    }, 'Kind: ', kind), _react2.default.createElement(_Typography2.default, {
      variant: 'subheading'
    }, nameValue, ' ', aliasValue ? ' (' + aliasValue + ')' : ""), directivesList, 'Selections: ', selections && selections.map(function (n) {
      return _this2.renderDefinition(n);
    }) || null);
  };

  QueryBuilderUI.prototype.renderArgument = function renderArgument(node) {
    var _this3 = this;

    var output = void 0;
    var value = node.value,
        name = node.name;
    var valueKind = value.kind,
        valueName = value.name,
        valueValue = value.value;

    switch (valueKind) {
      case "Variable":
        output = _react2.default.createElement(_Typography2.default, {
          color: 'textSecondary'
        }, 'Variable: $', valueName.value);
        break;

      case "StringValue":
        output = _react2.default.createElement(_TextField2.default, {
          label: name.value,
          value: valueValue || "",
          onChange: function onChange(event) {
            return _this3.onChangeArgument(event, value);
          }
        });
        break;
    }

    return output;
  };

  QueryBuilderUI.prototype.onChangeArgument = function onChangeArgument(event, node) {
    var value = event.target.value;

    _objectDestructuringEmpty(node.loc);

    return this.updateNode(node, value);
  };

  QueryBuilderUI.prototype.renderDefinitions = function renderDefinitions(definitions) {
    var _this4 = this;

    return definitions && definitions.map(function (definition) {
      return _this4.renderDefinition(definition);
    }) || null;
  };

  QueryBuilderUI.prototype.renderDefinition___ = function renderDefinition___(node) {
    var kind = node.kind,
        name = node.name,
        alias = node.alias,
        loc = node.loc,
        definitions = node.definitions,
        operation = node.operation,
        directives = node.directives,
        variableDefinitions = node.variableDefinitions,
        variable = node.variable,
        selectionSet = node.selectionSet,
        selections = node.selections;
    var classes = this.props.classes;
    var output = [];
    var nameValue = name && name.value;
    var aliasValue = alias && alias.value;

    switch (kind) {}

    var childs = Object.values(node);
    output.push(this.renderSuggestions(node));
    return _react2.default.createElement('div', {
      key: [kind, nameValue, aliasValue].filter(function (n) {
        return n;
      }).join("_"),
      className: classes.node
    }, _react2.default.createElement(_Typography2.default, {
      variant: 'headline',
      onClick: function onClick(event) {
        event.stopPropagation();
      }
    }, 'Kind: ', kind, '. ', nameValue ? nameValue + ' ' + (aliasValue ? ' (' + aliasValue + ')' : "") : null), output, this.renderChildDefinitions(childs));
  };

  QueryBuilderUI.prototype.renderSuggestions = function renderSuggestions(node) {
    var _props = this.props,
        schema = _props.schema,
        query = _props.query;
    var loc = node.loc;

    if (!loc) {
      return null;
    }

    var end = loc.end,
        start = loc.start; // let suggestions = getAutocompleteSuggestions(schema, query, point);
  };

  QueryBuilderUI.prototype.renderChildDefinitions = function renderChildDefinitions(values) {
    var _this5 = this;

    var output = [];
    values.map(function (n) {
      if (n) {
        if (n.kind) {
          output.push(_this5.renderDefinition(n));
        } else if (Array.isArray(n)) {
          output.push(_this5.renderChildDefinitions(n));
        }
      }
    });
    return output;
  };

  QueryBuilderUI.prototype.render = function render() {
    var _props2 = this.props,
        classes = _props2.classes,
        schema = _props2.schema,
        query = _props2.query;
    var _state = this.state,
        point = _state.point,
        parseError = _state.parseError;
    var elements = this.renderDocumentFromSchema();
    return _react2.default.createElement('div', {
      className: classes.root
    }, parseError ? _react2.default.createElement('div', null, _react2.default.createElement(_Typography2.default, {
      color: 'error'
    }, parseError.toString()), _react2.default.createElement('details', null, parseError.stack)) : null, elements);
  };

  return QueryBuilderUI;
}(_react.Component);

QueryBuilderUI.propTypes = process.env.NODE_ENV !== "production" ? {
  setQuery: _propTypes2.default.func.isRequired,
  query: _propTypes2.default.string.isRequired,
  schema: _propTypes2.default.instanceOf(_graphql.GraphQLSchema),
  classes: _propTypes2.default.object.isRequired
} : {};
var UI = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(QueryBuilderUI, props);
});

var ResultRenderer = function (_ResultViewer) {
  _inherits(ResultRenderer, _ResultViewer);

  function ResultRenderer() {
    _classCallCheck(this, ResultRenderer);

    return _possibleConstructorReturn(this, _ResultViewer.apply(this, arguments));
  }

  ResultRenderer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return true;
  };

  ResultRenderer.prototype.componentDidMount = function componentDidMount() {// Prevent parent styling
  };

  ResultRenderer.prototype.componentDidUpdate = function componentDidUpdate() {};

  ResultRenderer.prototype.componentWillUnmount = function componentWillUnmount() {};

  ResultRenderer.prototype.getCodeMirror = function getCodeMirror() {
    return {
      setSize: function setSize(size) {}
    };
  };

  ResultRenderer.prototype.render = function render() {
    var _this7 = this;

    return _react2.default.createElement('div', {
      className: 'result-window',
      ref: function ref(node) {
        _this7._node = node;
      }
    }, _react2.default.createElement(UI, this.props));
  };

  return ResultRenderer;
}(_ResultViewer2.ResultViewer);

exports.default = ResultRenderer;
module.exports = exports['default'];